import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getProjectDatesForResourceChart.query';

export const getProjectDatesForResourceChart = (params: QueryParams) => {
    const url = 'api/bo/getProjectDatesForResourceChart';
    return network.post(url, params).then((response) => {
        return response.data;
    });
};
